interface TipCardProps {
  eyebrow?: string;
  children: React.ReactNode;
}

export function TipCard({ eyebrow, children }: TipCardProps) {
  return (
    <div className="flex w-full flex-col gap-2 rounded-[16px] bg-white p-4 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
      {eyebrow && (
        <p className="font-mono text-[12px] font-medium leading-[1.4] tracking-[-0.24px] text-[#58534c]">
          {eyebrow}
        </p>
      )}
      <div className="text-[14px] leading-[1.4] text-[#1f1e1d]">
        {children}
      </div>
    </div>
  );
}
